export default {
  EASY: 'Easy',
  MEDIUM: 'Medium',
  HARD: 'Hard',
};
